import { render, staticRenderFns } from "./PRO_FindingSummaryDX.vue?vue&type=template&id=0f32d438&scoped=true&"
import script from "./PRO_FindingSummaryDX.vue?vue&type=script&lang=js&"
export * from "./PRO_FindingSummaryDX.vue?vue&type=script&lang=js&"
import style0 from "./PRO_FindingSummaryDX.vue?vue&type=style&index=0&id=0f32d438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32d438",
  null
  
)

export default component.exports